import Minutes from '@/pages/Workflows/CreateWorkflow/components/cron/cron-tab/minutes';
import Daily from '@/pages/Workflows/CreateWorkflow/components/cron/cron-tab/daily';
import Hourly from '@/pages/Workflows/CreateWorkflow/components/cron/cron-tab/hourly';
import Weekly from '@/pages/Workflows/CreateWorkflow/components/cron/cron-tab/weekly';
import Monthly from '@/pages/Workflows/CreateWorkflow/components/cron/cron-tab/monthly';

import {
  HeaderKeyType,
  HeaderValType,
  HeadersInterface,
  HeadersKeyInterface,
  MetadataInterface
} from '@/types/cron';

// This is Default CRON expression for Daily Runs
export const DefaultCronExpression = '0 0 00 1/1 * ? *'

export const HEADER: HeadersKeyInterface = {
  MINUTES: 'MINUTES',
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
};

const HEADER_VALUES: HeadersInterface = {
  MINUTES: 'Minutes',
  HOURLY: 'Hourly',
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
};

const defaultTabs: HeaderValType[] = [
  HEADER_VALUES.MINUTES,
  HEADER_VALUES.HOURLY,
  HEADER_VALUES.DAILY,
  HEADER_VALUES.WEEKLY,
  HEADER_VALUES.MONTHLY,
];

export const metadata: MetadataInterface[] = [
  {
    component: Minutes,
    name: HEADER_VALUES.MINUTES,
    initialCron: ['0', '0/1', '*', '*', '*', '?', '*']
  },
  {
    component: Hourly,
    name: HEADER_VALUES.HOURLY,
    initialCron: ['0', '0', '*', '1/1', '*', '?', '*']
  },
  {
    component: Daily,
    name: HEADER_VALUES.DAILY,
    initialCron: ['0', '0', '00', '1/1', '*', '?', '*']
  },
  {
    component: Weekly,
    name: HEADER_VALUES.WEEKLY,
    initialCron: ['0', '0', '00', '?', '*', '*', '*']
  },
  {
    component: Monthly,
    name: HEADER_VALUES.MONTHLY,
    initialCron: ['0', '0', '00', '1', '1/1', '?', '*']
  }
];

const validateHeaders = (headers: HeaderKeyType[]): HeaderValType[] => {
  const validatedHeaders: HeaderValType[] = [];
  headers.forEach(header => {
    if (!HEADER_VALUES[header]) {
      throw new Error('Invalid header ' + header);
      // Avoid duplicates
    } else if (validatedHeaders.indexOf(HEADER_VALUES[header]) === -1) {
      validatedHeaders.push(HEADER_VALUES[header]);
    }
  });
  return validatedHeaders;
}

/**
 * Validate and load headers
 * @param {*} options 
 */
export const loadHeaders = (options?: { headers: HeaderKeyType[] }): HeaderValType[] => {
  if (options) {
    if (options.headers) {
      if (!options.headers.length) {
        throw new Error('Atleast one header is required.');
      }
      return validateHeaders(options.headers);
    }
  }
  return defaultTabs;
};

export const CronTimeZones: Record<string, string> = {
  'PST': 'America/Los_Angeles',
  'EST': 'America/New_York',
  'IST': 'Asia/Kolkata',
  'UTC': 'UTC'
}
